<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <vx-card>
        <vs-table
          :max-items="paginationItems[0]"
          pagination
          :data="ClosingEntriesList"
          search
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("accounting.label.closingentries") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <v-select
                label="name"
                v-model="selectedOffice"
                :options="OfficesList"
                placeholder="Filter By Office"
                :reduce="(obj) => obj.id"
                @input="handleSelectedOption"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full font-semibold header-dropdown1"
              ></v-select>
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Closure' })"
                size="small"
                >{{ $t("accounting.label.createclosure") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("accounting.label.entityname") }}</vs-th>
            <vs-th>{{ $t("accounting.label.accountclosuredate") }}</vs-th>
            <vs-th>{{ $t("accounting.label.comments") }}</vs-th>
            <vs-th>{{ $t("accounting.label.closeaccountcreatedby") }}</vs-th>
            <vs-th class="tHeadCenter">{{
              $t("accounting.label.action")
            }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(accounts, index) in data">
              <vs-td :data="accounts.officeName">{{
                accounts.officeName
              }}</vs-td>
              <vs-td :data="accounts.closingDate">{{
                getDate(accounts.closingDate)
              }}</vs-td>
              <vs-td :data="accounts.comments">{{ accounts.comments }}</vs-td>
              <vs-td :data="accounts.createdByUsername">{{
                accounts.createdByUsername
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    title="View"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleSelected1(accounts.id)"
                    class="icon_row"
                  />
                  <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                      @click.stop="EditClosureMethod(accounts.id)"
                      class="icon_row"
                    />
                  <feather-icon
                    icon="TrashIcon"
                    title="delete"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteAccountPopup = true;
                      delId = accounts.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteAccountPopup"
      title="Closure"
      @deletePressed="deleteClosure(delId)"
      @cancelPressed="deleteAccountPopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [10, 20, 30],
      delId: 0,
      deleteAccountPopup: false,
      selectedOffice: "",
    };
  },
  components: { AtomSpinner, vSelect },
  computed: {
    ...mapState({
      ClosingEntriesList: (state) => state.accounting.closingEntriesList,
      OfficesList: (state) => state.accounting.officesList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async getClosingEntriesListMethod() {
      this.loading = true;
      try {
        this.$store.dispatch("accounting/getClosingEntriesListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getOfficeList() {
      try {
        this.$store.dispatch("accounting/getOfficesListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleSelectedOption(id) {
      try {
        this.$store.dispatch("accounting/filterClosureListByOfficeAction", id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteClosure(id) {
      try {
        this.deleteAccountPopup = false;
        await this.$store.dispatch("accounting/deleteClosureAction", id);
        this.getClosingEntriesListMethod();
        this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    EditClosureMethod(id) {
      this.$router.push({ name: "Edit Closure", params: { id: id } });
    },

    handleSelected1(id) {
      this.$router.push({
        name: "View Closure",
        params: { id: id },
      });
    },
  },
  watch: {
    selectedOffice(newVal) {
      if (newVal === null) {
        this.getClosingEntriesListMethod();
      }
    },
  },
  mounted() {
    this.getClosingEntriesListMethod();
    this.getOfficeList();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.header-dropdown1 {
  min-width: 200px !important;
}
</style>
